import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-stage-field-deep plan-grid-dark text-center text-cream" aria-label="Limited time offer" data-id="element-267" data-mp="369pga49jt16e">
      <div className="rule-gold h-2 w-full" aria-hidden="true" data-id="element-268" data-mp="31izawr14gybp" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-269" data-mp="31hef6y32n9c9">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-goldBright" data-id="element-270" data-mp="3g6u4saqv98qd">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-271" data-mp="3b8snnvd03jhj" /> Launch pricing ends in
        </p>
        <Countdown className="mt-5 scale-110" data-id="element-272" data-mp="3p80lokxfglk5" />
        <p className="mt-7 font-bold text-beige" data-id="element-273" data-mp="3l6os64bfng6o">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-forestSoft bg-forest p-4 text-sm" data-id="element-274" data-mp="1uu0uhg816876">
          <p className="font-bold text-cream" data-id="element-275" data-mp="1qu8qzhxhus8o">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-goldBright" data-id="element-276" data-mp="1qvjurhqxvzzs" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-forestDeep" data-id="element-277" data-mp="2xtam00o1wfm7">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold" data-id="element-278" data-mp="32qswvwlmp4wu" />
          </div>
          <p className="mt-1 text-right text-xs text-beige" data-id="element-279" data-mp="3gi7j0cau1m84">66% of spots taken</p>
        </div>
      </div>
      <div className="rule-gold h-2 w-full" aria-hidden="true" data-id="element-280" data-mp="3ljn4g5gx9ur1" />
    </section>;
}